import React from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { App2 } from './App2';
const path = window.location.pathname;
const Page = App;
const root = createRoot(document.getElementById('root')!);
root.render(<Page data-id="element-712" />);